import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NewsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
